import { NetworkError } from "./NetworkError";

export class HttpError extends NetworkError {
  constructor(public response: Response, request: Request, ...params: any[]) {
    super(request, ...params);
  }

  get message() {
    return (
      super.message +
      ` Es wurde der Status ${this.response.status} (${
        this.response.statusText
      }) zurückgegeben.`
    );
  }
}
